import React from "react";
import { useDispatch, useSelector } from "react-redux";

import { updateActiveStep } from "@/reducers/clientcreatejob";
import { createJobValidations } from "@/utilities/CommonText";
import { showErrorToast, showWarningToast } from "@/utilities/utils";

/**
 * Returns the JobSteps component with a list of steps and their respective titles, and handles click events for each step.
 *
 * @return {JSX.Element} The JobSteps component
 */
export const JobSteps = () => {
  const {
    activeStep,
    stepsValidated,
    getDayWiseApiLoading,
    jobData,
    skillsList,
  } = useSelector((state) => state.clientCreateJob);
  const dispatch = useDispatch();
  const stepsArr = [
    {
      step: 1,
      title: "Job Details",
      type: "jobDetails",
    },
    {
      step: 2,
      title: "Select Dates",
      type: "selectDates",
    },
    {
      step: 3,
      title: "Time Selection",
      type: "timeSelection",
    },
    {
      step: 4,
      title: "Verification",
      type: "verification",
    },
  ];
  return (
    <div className="Steps_Wrapper">
      <div className="rounded-lg bg-white p-6">
        <div className="grid select-none grid-cols-4 gap-6">
          {stepsArr.map((item, index) => {
            return (
              <div
                className={`flex cursor-pointer flex-col gap-2`}
                key={index}
                onClick={() => {
                  if (activeStep === 1 && stepsValidated[stepsArr[1].type]) {
                    if (
                      jobData.jobTitle === "" ||
                      jobData.jobTitle.trim() === ""
                    ) {
                      showErrorToast(createJobValidations.jobTitle);
                      return;
                    }
                    if (jobData.roleId === null) {
                      showErrorToast(createJobValidations.roleId);
                      return;
                    }
                    if (
                      jobData.jobDescription === "" ||
                      jobData.jobDescription.trim() === ""
                    ) {
                      showErrorToast(createJobValidations.jobDesc);
                      return;
                    }
                    // if (skillsList.length > 0) {
                    //   if (jobData.skills.length === 0) {
                    //     showErrorToast(createJobValidations.skills);
                    //     return;
                    //   }
                    // }
                  }
                  if (getDayWiseApiLoading) {
                    showWarningToast(createJobValidations.isFetchingRates, {
                      id: "isFetchingRates",
                    });
                    return;
                  }
                  if (stepsValidated[item.type]) {
                    dispatch(updateActiveStep(item.step));
                  }
                }}
              >
                <div className="flex h-[34px] items-end !gap-[23px]">
                  <h4
                    className={`text-[16px] font-semibold leading-[normal] ${stepsValidated[item.type] ? "text-blue" : "text-black"}`}
                  >
                    {item.step}
                  </h4>
                  <span
                    className={`text-[16px] leading-[normal] ${stepsValidated[item.type] ? "font-bold text-black" : "font-semibold text-txtColor"}`}
                  >
                    {item.title}
                  </span>
                </div>
                <div
                  className={`!h-[5px] rounded-sm ${stepsValidated[item.type] ? "bg-primary" : "bg-lightblue"}`}
                ></div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};
